import React, { useState, useEffect } from "react";
import Head from 'next/head'
import Link from 'next/link'
import { useRouter } from 'next/router'
import pluralize from 'pluralize'

import { FaMapMarkerAlt, FaHardHat, FaClock, FaWrench, FaCheckSquare, FaRegSquare } from "react-icons/fa";

import UserManager from "../lib/userManager"

import styles from './EmployerView.module.css'

export default function EmployerView({employer, jobs}) {  
  if(!employer) return(<div></div>);

  const buttonStyle = () => {
    if(employer.primary_color != null && employer.primary_color != undefined) {
      return {
        background: employer.primary_color,
        borderColor: employer.primary_color,
        color: getContrast(employer.primary_color)
      }
    }

    return null;
  }

  const headerStyle = () => {
    if(employer.primary_color != null && employer.primary_color != undefined) {
      return {
        color: getContrast(employer.primary_color)
      }
    } else {
      return {
        color: "#fff"
      }
    }
  }

  const getContrast = (hexcolor) => {
    if(!hexcolor) return;

    // If a leading # is provided, remove it
    if (hexcolor.slice(0, 1) === '#') {
      hexcolor = hexcolor.slice(1);
    }
  
    // If a three-character hexcode, make six-character
    if (hexcolor.length === 3) {
      hexcolor = hexcolor.split('').map(function (hex) {
        return hex + hex;
      }).join('');
    }
  
    // Convert to RGB value
    var r = parseInt(hexcolor.substr(0,2),16);
    var g = parseInt(hexcolor.substr(2,2),16);
    var b = parseInt(hexcolor.substr(4,2),16);
  
    // Get YIQ ratio
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  
    // Check contrast
    return (yiq >= 128) ? 'black' : 'white';
  
  };

  const jobBoxes = Object.keys(jobs).map(category => {
    const jobElements = jobs[category].map(job => {
      return(
        <div className={styles["job"]}>
          <p className={styles["job-name"] + " text-truncate text-wrap"}>{job.name}</p>
          <p className={styles["job-info"]}><a target="_blank" className={styles["job-location"] + " cleanest-link"} href={"https://www.google.com/maps?q=" + job.location}><FaMapMarkerAlt style={{marginBottom: 3, marginRight: 3}}/>{job.location}</a>  <span><span className={styles["location-divider"]}>&nbsp;&nbsp;•&nbsp;&nbsp;</span></span><span className={styles["job-wage"]}>${job.min_wage} - ${job.max_wage}/hour</span><span className={styles["wage-divider"]}>&nbsp;&nbsp;•&nbsp;&nbsp;</span>{job.work_type ? job.work_type.name : "N/A"} &nbsp;&nbsp;•&nbsp;&nbsp; {job.industry ? job.industry.name : "N/A"}</p>
          <Link href={"/e/" + job.employer_slug + "/" + job.slug}>
            <a className={"btn btn-primary " + styles["job-apply"]} style={buttonStyle()}>Apply Now</a>
          </Link>
        </div>
      )
    })

    return(
      <div className={styles["jobs-subcontainer"]}>
        <EmployerSubBox title={pluralize.plural(category)} color={employer.secondary_color}>
          {jobElements}
        </EmployerSubBox>
      </div>
    )
  })

  console.log(getContrast(employer.primary_color), headerStyle())

  const emptyJobs = () => {
    return(
      <div className={styles["jobs-subcontainer"]}>
        <div className={styles["employer-sub-box"]} style={{borderColor: (employer.secondary_color ? employer.secondary_color : "")}}>
          <h2 className={styles["empty-sub-box-title"]}>{`${employer.name} does not have any open roles at this time!`}</h2>
          <div style={{marginTop: 50, marginBottom: 30, textAlign: "center"}}>
            <img src={"/empty-jobs-v3.svg"} width={"40%"}/>
          </div>
        </div>
      </div>
    )
  }
  
  return (
    <div className={"container"}>
      <div className="row justify-content-center">
        <div className="col-lg-9">
          <div className={styles["employer-header"]}>
            <h1 className={styles["employer-name"]} style={headerStyle()}>{employer.name}</h1>
          </div>
          <div className={styles["employer-subheader"]}>
            <p className={styles["employer-type-and-location"]} style={headerStyle()}>{employer.etype} <FaMapMarkerAlt/> {employer.location}</p>
          </div>
          <div className={styles["employer-jobs-container"]}>
            <h1 className={styles["employer-jobs-head"]} style={headerStyle()}>Open Roles</h1>
            {jobBoxes.length > 0 ? jobBoxes : emptyJobs()}
          </div>
        </div>
      </div>
    </div>
  )
}


function EmployerSubBox({children, title, color}) {
  return(
    <div className={styles["employer-sub-box"]} style={{borderColor: (color ? color : "")}}>
      <h2 className={styles["sub-box-title"]}>{title}</h2>
      {children}
    </div>
  )
}
